var scope_0 = require('/home/travis/build/st4sd/overview/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/037eec9701418ece3ca80c2f67de4dbc.js').default;
var scope_1 = require('/home/travis/build/st4sd/overview/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/32d39034c58bcce36f099453808efd98.js').default;
var scope_2 = require('/home/travis/build/st4sd/overview/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/59bbacb2a628ac393270618ee6a0379d.js').default;
var scope_3 = require('/home/travis/build/st4sd/overview/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/686478a0868d9834a06b511b62ab8dbb.js').default;
var scope_4 = require('/home/travis/build/st4sd/overview/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6a66e550493d496f8e658123bda13be6.js').default;
var scope_5 = require('/home/travis/build/st4sd/overview/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/874b4ed0db7e2dcf57e308b0d04dc2fa.js').default;
var scope_6 = require('/home/travis/build/st4sd/overview/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a12d0235ef4457c672959552412b5d14.js').default;
var scope_7 = require('/home/travis/build/st4sd/overview/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b7653acdff434915a53f19bb51d90ff6.js').default;
var scope_8 = require('/home/travis/build/st4sd/overview/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bb7f5caaea011a6c07471c42159ac1f3.js').default;
var scope_9 = require('/home/travis/build/st4sd/overview/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d8572a98da429f85cba7e248b099abbe.js').default;
var scope_10 = require('/home/travis/build/st4sd/overview/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e0920336c76717d51d777eb24287480d.js').default;
var scope_11 = require('/home/travis/build/st4sd/overview/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_12 = require('/home/travis/build/st4sd/overview/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fbc17fa17f4688ae0a4c5c2bba09439c.js').default;
var scope_13 = require('/home/travis/build/st4sd/overview/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fe6ad77a9a6e48d7b44d7c2f2c9fe6e4.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13 )
    